<app-breadcrumb [master]="'Marketing'" [parentName]="'Stan magazynowy'" [name]="'Lista'"></app-breadcrumb>
<div fxLayout="column" fxLayoutGap="15px" class="list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="list-filters">

    <mat-form-field class="list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dynamic-dict class="list-filter"
                      [multiple]="false"
                      [dictType]="DYNAMIC_DICTIONARY_CATEGORY"
                      [label]="'Kategoria'"
                      [(ngModel)]="initialFilters.category" name="category">
    </app-dynamic-dict>

    <mat-form-field class="list-filter">
      <mat-label>Nazwa produktu</mat-label>
      <input matInput name="contains$productName" [(ngModel)]="initialFilters.contains$productName">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Ilość produktu od</mat-label>
      <input type="number" matInput name="gte$productAmount" [(ngModel)]="initialFilters.gte$productAmount">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Ilość produktu do</mat-label>
      <input type="number" matInput name="lte$productAmount" [(ngModel)]="initialFilters.lte$productAmount">
    </mat-form-field>

    <app-dynamic-dict class="list-filter"
                      [multiple]="false"
                      [dictType]="DYNAMIC_DICTIONARY_WAREHOUSE"
                      [label]="'Magazyn'"
                      [(ngModel)]="initialFilters.warehouse" name="warehouse">
    </app-dynamic-dict>

    <mat-form-field class="list-filter">
      <mat-label>Cena jednostkowa zakupu od</mat-label>
      <input type="number" matInput name="gte$productPrice" [(ngModel)]="initialFilters.gte$productPrice">
    </mat-form-field>

    <mat-form-field class="list-filter">
      <mat-label>Cena jednostkowa zakupu do</mat-label>
      <input type="number" matInput name="lte$productPrice" [(ngModel)]="initialFilters.lte$productPrice">
    </mat-form-field>

    <app-datepicker
      class="list-filter"
      label="Data zakupu od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$purchaseDate" name="gte$purchaseDate"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data zakupu do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$purchaseDate" name="lte$purchaseDate"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data ważności od"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.gte$expirationDate" name="gte$expirationDate"
    ></app-datepicker>

    <app-datepicker
      class="list-filter"
      label="Data ważności do"
      placeholder="2000-01-01"
      [required]="false"
      [(ngModel)]="initialFilters.lte$expirationDate" name="lte$expirationDate"
    ></app-datepicker>

    <app-dict class="list-filter"
              [multiple]="false" [dictType]="'marketing_companies'"
              [label]="'Firma'"
              [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <mat-form-field appearance="standard" class="list-filter">
      <mat-label>Wymagany protokół</mat-label>
      <mat-select [(ngModel)]="initialFilters.protocol" name="protocol">
        <mat-option [value]="undefined">Wszystkie</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

  </form>

  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
    <div>
      <button *ngIf="(userPermissions | async).marketing.write" (click)="addProduct()" mat-stroked-button color="primary">
        <mat-icon>add</mat-icon> <span> Dodaj produkt</span>
      </button>
    </div>
    <div fxLayout="row" fxLayoutGap="15px">
      <button *ngIf="(userPermissions | async).marketing.read_report" (click)="downloadReport()"
              mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span>
      </button>
      <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
      <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
    </div>
  </div>

  <table mat-table [dataSource]="warehouseProducts">

    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element" style="text-align: center">
        <img *ngIf="element.location" src="/rest/crm/product/{{element.uuid}}/image" alt="Zdjęcie" height="30"/>
      </td>
    </ng-container>

    <ng-container matColumnDef="id" >
      <th mat-header-cell  *matHeaderCellDef> ID</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/stan-magazynowy/szczegoly', element.uuid]"> {{element.recordId}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef> Kategoria </th>
      <td mat-cell *matCellDef="let element">
        {{element?.category?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef> Nazwa produktu </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/stan-magazynowy/szczegoly', element.uuid]"> {{element.productName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="productAmount">
      <th mat-header-cell *matHeaderCellDef> Ilość produktu </th>
      <td mat-cell *matCellDef="let element">
        {{element.productAmount}}
      </td>
    </ng-container>

    <ng-container matColumnDef="warehouse">
      <th mat-header-cell *matHeaderCellDef> Magazyn </th>
      <td mat-cell *matCellDef="let element">
        {{element?.warehouse?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{element.company?.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="protocol">
      <th mat-header-cell *matHeaderCellDef> Wymagany protokół </th>
      <td mat-cell *matCellDef="let element">
        {{element.protocol ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
